const SAFE_VALUE = /^[a-z0-9][a-z0-9_-]{0,79}$/i
const ATTRIBUTION_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"]
const STORAGE_KEY = "influxiveLeadAttribution"

export const isProductionAnalytics = () =>
  typeof window !== "undefined" &&
  process.env.NODE_ENV === "production" &&
  window.location.hostname === "www.influxive.com"

export const safeSelection = value => {
  const candidate = String(value || "").trim()
  return SAFE_VALUE.test(candidate) ? candidate : undefined
}

export const captureAttribution = () => {
  if (typeof window === "undefined") return {}
  let previous = {}
  try { previous = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || "{}") } catch (_) {}
  const params = new URLSearchParams(window.location.search)
  const values = { ...previous }
  ATTRIBUTION_KEYS.forEach(key => {
    const value = params.get(key)
    if (value) values[key] = value.slice(0, 200)
  })
  if (!values.landing_page) values.landing_page = window.location.pathname
  if (!values.referrer && document.referrer) values.referrer = document.referrer.slice(0, 500)
  try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(values)) } catch (_) {}
  return values
}

export const trackEvent = (name, params = {}) => {
  if (!isProductionAnalytics() || !window.influxiveAnalyticsConsent || typeof window.gtag !== "function") return
  window.gtag("event", name, {
    page_path: window.location.pathname,
    page_location: window.location.origin + window.location.pathname,
    ...Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined)),
  })
}
